import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react'
import { useUpdateBrandMutation } from '../../features/fullApi';

export default function EditDialog({openEdit, setOpenEdit, handleUpdateBrand, item}) {

    const user = JSON.parse(localStorage.getItem('user'))
    const [updateBrand] = useUpdateBrandMutation()


    const onSubmit = async(values, actions) => {
        console.log("Called on submit", values.brandName)
          updateBrand({_id: item._id, brandName: values.brandName }, { 
          headers: {
              'Token': `Bearer ${user?.accessToken}`
          }
          }, {id: item._id})
          .then(res => {
            console.log("res is")
          })
          .catch((e) => {
          console.log("e is", e)
          })
      }
      
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          brandName: item?.brandName,
        },
        onSubmit,
      });

    return (
        <form onSubmit={handleSubmit} >
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpenEdit(false)} open={openEdit}>
                <DialogTitle id='dialog-title'>
                    Edit Brand
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{color: "red"}}>You are editing {item.brandName}</DialogContentText>
                    <TextField
                        id="brandName"
                        type="text"
                        margin="dense"
                        value={values.brandName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={values.brandName ? "" : "BrandName"}
                    />
                    {errors.brandName && touched.brandName && (
                        <p className="error">{errors.brandName}</p>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => setOpenEdit(false)}
                        variant="contained"
                    >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => handleUpdateBrand({id: item, brandName: values.brandName})}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}